import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '../../../icon/components/icon/icon.component';
import { MenuItem } from '../../models/menu-item';

@Component({
  selector: 'app-menu-item-content-default',
  imports: [IconComponent],
  templateUrl: './menu-item-content-default.component.html',
  styleUrls: ['./menu-item-content-default.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemContentDefaultComponent {
  @Input({ required: true }) public item!: MenuItem;
}
